import moment from 'moment';

export const formats = {
    'short': 'DD MMM (dd)',
    'long': 'DD MMMM (dddd)',
    'short_year': 'DD MMMM YYYY',
    'long_year': 'DD MMMM YYYY'
};

export function formatDates(from, to , format = 'short', separator = ' - '){
    format = getFormat(format);
    from = formatDate(from, format);
    to = formatDate(to, format);
    if(from === to) {
        return from ;
    } else {
        return from + separator + to;
    }
}

export function formatDate(date, format = 'short') {
    return moment(date).format(format);
}

export function getFormat(format = 'short') {
    if(formats.hasOwnProperty(format)){
        format = formats[format];
    }
    return format;
}
